import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { motion } from 'framer-motion';
import { useId } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export interface TabItem {
  value: string;
  label: string;
  route?: string;
}

interface CustomTabsProps {
  tabs: TabItem[];
  activeTab?: string;
  className?: string;
  onChange?: (tab: string) => void;
}

export function CustomTabs({ tabs, activeTab, className, onChange }: CustomTabsProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const pillId = useId();

  const currentTab =
    activeTab ||
    tabs.find((tab) => tab.route && location.pathname.includes(tab.route))
      ?.value ||
    tabs[0].value;

  const handleChange = (tab: string, route?: string) => {
    if (onChange) {
      onChange(tab);
      return;
    }
    if (route) navigate(route);
  };

  return (
    <Tabs value={currentTab}>
      <TabsList
        className={className || 'flex gap-2 bg-[#18181B] p-1 rounded-full'}
      >
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            onClick={() => handleChange(tab.value, tab.route)}
            className='relative px-4 py-1 text-sm rounded-full data-[state=active]:bg-transparent data-[state=active]:text-white data-[state=active]:shadow-none'
          >
            {currentTab === tab.value && (
              <motion.span
                layoutId={pillId}
                className='absolute inset-0 rounded-full bg-[#27272A]'
                transition={{ type: 'spring', bounce: 0.15, duration: 0.35 }}
              />
            )}
            <span className='relative z-10'>{tab.label}</span>
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
